/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-new */
/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_API, ListingDataInterface } from '../constants/constants';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { request } from '../utility/utility';
import { SearchDataInterface } from '../pageParts/filter/filterTypes';

export type UserDataInterface = {
  listings: ListingDataInterface[];
  ownListings: ListingDataInterface[];
  ownFavoriteListings: ListingDataInterface[];
  totalPages: number;
  totalFavoritePages: number;
  searchData: SearchDataInterface | null;
  pageNumber: number;
  pageFavoritesNumber: number;
  ownerUsername: string;
  ownerEmail: string;
  totalOffers: number;
};

const initialState: UserDataInterface = {
  listings: [],
  ownListings: [],
  ownFavoriteListings: [],
  totalPages: 1,
  totalFavoritePages: 1,
  searchData: null,
  pageNumber: 1,
  pageFavoritesNumber: 1,
  ownerUsername: '',
  ownerEmail: '',
  totalOffers: 0,
};

export const getListings = createAsyncThunk(
  'listingsData/getData',
  async (page: number = 1) => {
    const response = await request(`/listings/${page}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-type': 'application/json',
      },
    });
    console.log(response);
    return response;
  }
);

export const getFilteredListings = createAsyncThunk(
  'listingsData/getFilteredData',
  async (args: {
    filters: {
      name?: string;
      category?: string;
      city?: string;
      price?: number;
    };
    page: number;
  }) => {
    const { filters, page } = args;
    const searchParams = new URLSearchParams();

    if (filters.name) {
      searchParams.append('name', filters.name);
    }
    if (filters.category) {
      searchParams.append('category', filters.category);
    }
    if (filters.city) {
      searchParams.append('city', filters.city);
    }
    if (filters.price) {
      searchParams.append('price', filters.price.toString());
    }

    const response = await request(
      `/offers/${page}/?${searchParams.toString()}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response;
  }
);

export const createListing = createAsyncThunk(
  'listingData/listing',
  async (formData: FormData) => {
    const response = await axios.post(
      `${BASE_URL_API}/create-listing`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  }
);

export const updateListing = createAsyncThunk(
  'listingData/updateListing',
  async ({ offerId, formData }: { offerId: number; formData: FormData }) => {
    const response = await axios.patch(
      `${BASE_URL_API}/update-offer/${offerId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  }
);

export const like = createAsyncThunk(
  'listingData/like',
  async (listingId: number) => {
    const response = await request(`/favorites/like/${listingId}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  }
);

export const countOffers = createAsyncThunk('listing/total', async () => {
  const response = await request('/total-offers', {
    method: 'Get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    },
  });
  return response;
});

export const unlike = createAsyncThunk(
  'listingData/unlike',
  async (listingId: number) => {
    const response = await request(`/favorites/unlike/${listingId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  }
);

export const deleteListing = createAsyncThunk(
  'listingData/deleteListing',
  async (listingId: number) => {
    const response = await request(`/listings/${listingId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  }
);

export const getOwnListings = createAsyncThunk(
  'listingData/getOwnListing',
  async (page: number = 1) => {
    const response = await request(`/profile/listings/${page}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  }
);

export const getOwnFavoriteListings = createAsyncThunk(
  'listingData/getOwnFavoriteListing',
  async (page: number = 1) => {
    const response = await request(`/profile/favorites/${page}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  }
);

export const resetOffers = createAsyncThunk('listing/reset', async () => {
  const response = await request('/offers-reset', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    },
  });
  return response;
});

const listingsData = createSlice({
  name: 'listings',
  initialState,
  reducers: {
    setData: (state, action) => {
      state.listings = action.payload;
    },
    setSearchData: (state, action) => {
      state.searchData = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setFavoritePageNumber: (state, action) => {
      state.pageFavoritesNumber = action.payload;
    },
    setFavoriteOnCard: (state, action) => {
      const listing = state.listings.find((l) => l.id === action.payload);
      if (listing) {
        listing.isFavorite = !listing?.isFavorite;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListings.fulfilled, (state, action) => {
        const data = action.payload.offers;
        const pages = action.payload.totalPages;
        state.searchData = null;
        state.listings = data;
        state.totalPages = pages;
      })
      .addCase(createListing.fulfilled, (state, action) => {
        const data = action.payload.response;
        console.log(data);
      })
      .addCase(createListing.rejected, (state, action) => {
        console.log('errData');
      })
      .addCase(like.fulfilled, (state, action) => {
        console.log('Like successful:', action.payload);
      })
      .addCase(like.rejected, (state, action) => {
        console.error('Like failed:', action.error);
      })
      .addCase(unlike.fulfilled, (state, action) => {
        console.log('Unlike successful:', action.payload);
      })
      .addCase(unlike.rejected, (state, action) => {
        console.error('Unlike failed:', action.error);
      })
      .addCase(getOwnListings.fulfilled, (state, action) => {
        const data = action.payload;
        console.log(data);
        state.ownListings = data.offers;
        state.totalPages = data.totalPages;
      })
      .addCase(getOwnListings.rejected, (state, action) => {
        console.log('errData');
      })
      .addCase(getOwnFavoriteListings.fulfilled, (state, action) => {
        const data = action.payload;
        console.log(data);
        state.ownFavoriteListings = data.offers;
        state.totalFavoritePages = data.totalPages;
      })
      .addCase(getOwnFavoriteListings.rejected, (state, action) => {
        console.log(action);
      })
      .addCase(updateListing.fulfilled, (state, action) => {
        const data = action.payload;
        console.log(data);
        console.log('fulfield');
      })
      .addCase(updateListing.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(getFilteredListings.fulfilled, (state, action) => {
        const data = action.payload;
        const { totalPages } = action.payload;
        state.listings = data.offers;
        state.totalPages = totalPages;
      })
      .addCase(countOffers.fulfilled, (state, action) => {
        const data = action.payload;
        state.totalOffers = data;
      })
      .addCase(resetOffers.fulfilled, (state, action) => {
        const data = action.payload;
        state.totalOffers = data;
      });
  },
});

export const {
  setData,
  setSearchData,
  setPageNumber,
  setFavoritePageNumber,
  setFavoriteOnCard,
} = listingsData.actions;
export default listingsData;
